import classNames from "classnames";
import * as _ from "lodash";
import * as React from "react";

const isNumber = (value: any) => _.isNumber(value) && !_.isNaN(value);

const isNumOrStr = (value: any) => isNumber(value) || _.isString(value);

const defaultFormatter = (value: any) =>
  _.isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1])
    ? value.join(" ~ ")
    : value;

class EffectChartTooltipContent extends React.Component<any> {
  public static defaultProps = {
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    separator: " : ",
  };

  public renderContent() {
    const { payload, separator, formatter, itemStyle, itemSorter } = this.props;

    if (payload && payload.length) {
      const listStyle = { padding: 0, margin: 0 };

      const items = payload.sort(itemSorter).map((entry: any, i: any) => {
        const finalItemStyle = {
          color: entry.color || "#000",
          display: "block",
          paddingBottom: 4,
          paddingTop: 4,
          ...itemStyle,
        };
        const finalFormatter = entry.formatter || formatter || defaultFormatter;
        let { name, value } = entry;
        if (finalFormatter) {
          const formatted = finalFormatter(value, name, entry, i);
          if (Array.isArray(formatted)) {
            [value, name] = formatted;
          } else {
            value = formatted;
          }
        }
        return (
          <li
            className="recharts-tooltip-item"
            key={`tooltip-item-${i}`}
            style={finalItemStyle}
          >
            {isNumOrStr(name) ? (
              <span className="recharts-tooltip-item-name">{name}</span>
            ) : null}
            {isNumOrStr(name) ? (
              <span className="recharts-tooltip-item-separator">
                {separator}
              </span>
            ) : null}
            <span className="recharts-tooltip-item-value">{value}</span>
            <span className="recharts-tooltip-item-unit">
              {entry.unit || ""}
            </span>
          </li>
        );
      });

      return (
        <ul className="recharts-tooltip-item-list" style={listStyle}>
          <li
            className="recharts-tooltip-item"
            style={{
              color: "#000",
              display: "block",
              paddingBottom: 4,
              paddingTop: 4,
              ...itemStyle,
            }}
          >
            <b>
              {payload &&
                payload.length > 0 &&
                payload[0].payload &&
                payload[0].payload.label}
            </b>
          </li>
          {items}
        </ul>
      );
    }

    return null;
  }

  public render() {
    const {
      wrapperClassName,
      contentStyle,
      labelClassName,
      labelStyle,
      label,
      labelFormatter,
    } = this.props;
    const finalStyle = {
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      margin: 0,
      padding: 10,
      whiteSpace: "nowrap",
      ...contentStyle,
    };
    const finalLabelStyle = {
      margin: 0,
      ...labelStyle,
    };
    const hasLabel = isNumOrStr(label);
    let finalLabel = hasLabel ? label : "";
    const wrapperCN = classNames("recharts-default-tooltip", wrapperClassName);
    const labelCN = classNames("recharts-tooltip-label", labelClassName);

    if (hasLabel && labelFormatter) {
      finalLabel = labelFormatter(label);
    }

    return (
      <div className={wrapperCN} style={finalStyle}>
        <p className={labelCN} style={finalLabelStyle}>
          {finalLabel}
        </p>
        {this.renderContent()}
      </div>
    );
  }
}

export default EffectChartTooltipContent;



// WEBPACK FOOTER //
// ./src/components/EffectChartTooltipContent.tsx